import { Component, OnInit } from '@angular/core';
import { AppData } from 'src/app/services/appdata.service';

@Component({
  selector: 'app-cagbc-admin',
  templateUrl: './cagbc-admin.component.html',
  styleUrls: ['./cagbc-admin.component.css']
})
export class CagbcAdminComponent implements OnInit {

  constructor(
    private appData: AppData
  ) { 
    this.appData.set('app_type', 'cagbc_invoice');
  }

  ngOnInit(): void {
  }

}
